/**
 * Mapa de path da rota → lista de tutoriais em vídeo.
 *
 * Estrutura de cada item:
 *   titulo: texto exibido na lista e no cabeçalho do player
 *   url:    caminho do arquivo servido pelo Nginx (/tutoriais/nome.mp4)
 *
 * Regras:
 *  - Uma rota pode ter múltiplos vídeos (ex: um por perfil de usuário).
 *  - Se a rota tiver apenas 1 vídeo, o player abre direto sem mostrar a lista.
 *  - Para adicionar um novo tutorial: basta inserir uma entrada aqui.
 *    Nenhum outro arquivo precisa ser alterado.
 *
 * Os arquivos .mp4 ficam em /var/www/tutoriais/ no servidor Linux
 * e são servidos pelo Nginx em https://adve.dev/tutoriais/.
 */
export const TUTORIAIS = {
  '/app/indicadores-stereotype': [
    {
      titulo: 'Análise Operacional — Colaborador',
      url: '/tutoriais/Colaborador_-_Analise_operacional_legendado.mp4',
    },
  ],

  '/app/evaluar': [
    // Dois perfis diferentes acessam a mesma tela com funções distintas
    {
      titulo: 'Avaliar — Assessor',
      url: '/tutoriais/Assessor-Avaliar_no_Sistema_AdvEstrategico_legendado.mp4',
    },
    {
      titulo: 'Avaliar — Auditor',
      url: '/tutoriais/Auditor_-_Avaliar_Planejamento_Estrategico_legendado.mp4',
    },
  ],

  '/app/feedback': [
    // Dois fluxos distintos dentro da tela de Feedback
    {
      titulo: 'Criação de Plano de Ação - Perfil Colaborador',
      url: '/tutoriais/Criacao_de_Plano_de_Acao_no_AdvEstrategico_legendado.mp4',
    },
    {
      titulo: 'Gestão de Plano de Ação - Perfil Gestão de Controle',
      url: '/tutoriais/Gestao_de_Plano_de_Acao_no_AdvEstrategico_legendado.mp4',
    },
  ],

  '/app/avances': [
    {
      titulo: 'Tela de Avanços',
      url: '/tutoriais/Tela_Avancos_legendado.mp4',
    },
  ],

  '/app/reportes': [
    {
      titulo: 'Painéis - Dashboard',
      url: '/tutoriais/paineis_legendado.mp4',
    },            
    {
      titulo: 'Painéis - Histórico',
      url: '/tutoriais/historico_legendado.mp4',
    },     
    {
      titulo: 'Painéis - PDCA',
      url: '/tutoriais/pdca_legendado.mp4',
    },     
    {
      titulo: 'Painéis - Comparativo',
      url: '/tutoriais/comparativo_legendado.mp4',
    },           
  ],

  '/app/kpi-analysis': [
    // Duas visões dentro da mesma tela: estratégica (macro) e tática (operacional)
    {
      titulo: 'Análise Estratégica',
      url: '/tutoriais/Analise_Estrategica_no_AdvEstrategico_legendado.mp4',
    },
    {
      titulo: 'Análise Tática',
      url: '/tutoriais/Analise_Tatica_no_AdvEstrategico_legendado.mp4',
    },
  ],
}

// Rota raiz do app: reúne todos os tutoriais cadastrados acima em uma única lista,
// permitindo acesso a todos os vídeos a partir da tela inicial (/app).
TUTORIAIS['/app'] = Object.values(TUTORIAIS).flat()

/**
 * Busca os tutoriais correspondentes ao path atual da rota.
 *
 * Aceita paths com sub-rotas (ex: /app/feedback/detalhe/123) e retorna
 * os tutoriais do prefixo mais específico encontrado no mapa.
 * Retorna null se nenhuma entrada corresponder — nesse caso o botão não aparece.
 */
export function findTutoriais(currentPath) {
  // Filtra todas as chaves que são prefixo do path atual,
  // depois ordena do mais longo para o mais curto para pegar o match mais específico
  const match = Object.keys(TUTORIAIS)
    .filter(key => currentPath === key || currentPath.startsWith(key + '/'))
    .sort((a, b) => b.length - a.length)[0]

  return match ? TUTORIAIS[match] : null
}
